<script>
import baseMixin from '@/mixins/baseMixin'
import { TimesheetSubmitResult } from '@/shared/constants/timesheet/TimesheetSubmitResult'

export default {
  name: 'TimesheetSubmitIssuesAlert',
  mixins: [baseMixin],
  props: {
    issues: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      showDetails: false,
    }
  },
  computed: {
    numberOfIssues() {
      return this.issues.length
    },
    compIssuesText() {
      return this.$tc('timesheets.submit.issues.description', [
        this.numberOfIssues,
      ])
    },
    compMoreDetailsLink() {
      return this.showDetails
        ? this.$t('timesheets.submit.issues.hideDetailsLink')
        : this.$t('timesheets.submit.issues.showDetailsLink')
    },
  },
  methods: {
    getTextFromStatus(status) {
      switch (status) {
        case TimesheetSubmitResult.alreadyApprovedForInvoice:
          return this.$t('timesheets.submit.issues.alreadyApprovedForInvoice')
        case TimesheetSubmitResult.alreadyInvoiced:
          return this.$t('timesheets.submit.issues.alreadyInvoiced')
        case TimesheetSubmitResult.alreadyCancelled:
          return this.$t('timesheets.submit.issues.alreadyCancelled')
        case TimesheetSubmitResult.alreadyActioned:
          return this.$t('timesheets.submit.issues.alreadyActioned')
        default:
          return this.$t('timesheets.submit.issues.unknown')
      }
    },
  },
}
</script>

<template>
  <v-alert dismissible type="error" text class="mb-8">
    <p :class="showDetails ? 'mb-4' : 'mb-0'">
      {{ compIssuesText }}

      <span
        data-testid="timesheet-submit-issues-alert-details-link"
        class="text-decoration-underline cursor-pointer ml-2"
        @click="showDetails = !showDetails"
        >{{ compMoreDetailsLink }}</span
      >
    </p>

    <ul
      v-if="showDetails"
      class="white-bg rounded-xl"
      data-testid="timesheet-submit-issues-alert-details-list"
    >
      <li v-for="issue of issues" :key="issue.bookingId">
        <p class="my-0">
          #{{ issue.bookingId }} - {{ getTextFromStatus(issue.status) }}
        </p>
      </li>
    </ul>
  </v-alert>
</template>
